import colors from "@/theme/colors";
import { Box, DialogTitle, IconButton, Typography } from "@mui/material";
import Image from "next/image";
import { SetStateAction } from "react";

const TermsAndConditions = ({
  onClose,
}: {
  onClose: (value: SetStateAction<boolean>) => void;
}) => {
  return (
    <Box sx={{ padding: "24px", position: "relative" }}>
      <IconButton
        onClick={() => onClose(false)}
        sx={{ position: "absolute", top: 24, left: 24, padding: 0 }}
      >
        <Image src="/assets/close.svg" alt="close" width={35} height={35} />
      </IconButton>
      <DialogTitle sx={{ padding: 0 }}>
        <Typography fontSize={24} fontWeight={300} mb={3}>
          תנאים ותקנון
        </Typography>
      </DialogTitle>
      <Box>
        <Typography fontSize={14} color={colors.black} fontWeight={300}>
          מחשבון המימון (להלן: "המחשבון") מיועד לצורך המחשה בלבד. מודגש כי
          המידע, הנתונים, החישובים והתוצאות המוצגים במסגרת המחשבון (להלן:
          "הנתונים") מסופקים בלעדית ע"י בנק ו/או גופי מימון המתמחים בכך (להלן:
          "הגורם המממן") ומוצגים כפי שהתקבלו ממנו ( IS-AS) ככלי עזר בלבד.
          החישובים הינם סימולציות בלבד. בשום מקרה, אין לראות בנתונים הצעה ו/או
          ייעוץ כלליים ו/או המתחשבים בנתונים ובצרכים המיוחדים שלך לביצוע פעולות
          ו/או עסקאות כלשהן ואין בהם משום המלצה ו/או יעוץ ו/או הבעת דעה בקשר
          לכדאיות רכישת רכב באמצעות מימון ו/או באיזה מהמסלולים המוצגים במחשבון
          והם אינם מהווים תחליף לשיקול דעתך העצמאי. דלק מוטורס לא תישא בכל
          אחריות ו/או נזק מכל סוג שהוא בקשר עם השימוש במחשבון וההסתמכות עליו.
          מתן האשראי כפוף לשיקול דעת הגורם המממן. תנאי ההלוואה ושיטת החזר
          ההלוואה ייקבעו ע"י הגורם המממן בעת העמדת ההלוואה. אישור ההלוואות,
          המסלולים השונים ותנאי ההלוואות בהתאם לקריטריונים של הגורם המממן
          ומותנים באישורו הבלעדי. תנאי ההלוואות המחייבים הם אלה המפורטים בחוזים
          שיחתמו בין הלווים לבין הגורם המממן. תוצאות סכומי ההחזר החודשי המוצגים
          במחשבון כוללים קרן וריבית בלבד, בגין עסקת התשלומים ובגין התשלום בסוף
          התקופה. סכום הריבית נגזר מריבית הפריים לפי המסלול הרלוונטי שנבחר ועשוי
          להשתנות מעת לעת. החישוב אינו לוקח בחשבון שינויים בריבית כאמור
          ובתשלומים נלווים העשויים להתווסף כגון עמלות הגורם המממן, אגרת רישוי
          ועוד. לפיכך, מודגש כי המחיר הכולל המוצג בסימולציות הכולל את כלל מרכיבי
          התשלום (מקדמה, תשלומים, תשלום בסוף תקופה, עמלות וכו') הינו גבוה
          מהתשלום במזומן עבור הרכב. מחיר הרכב המצוין באתר כולל מע"מ ואינו סופי.
          המחיר העדכני יקבע על פי מחירון החברה התקף בעת ביצוע התשלום המלא ובהתאם
          לאמור בהסכם הזמנת הרכב שתנאיה מהווים חלק בלתי נפרד מהרשום במסמך זה. אי
          עמידה בפירעון ההלוואה יגרור חיוב בריבית פיגורים והגורם המממן יהיה רשאי
          לנקוט בהליכים משפטיים, לרבות הליכי הוצאה לפועל. הגלישה והשימוש במחשבון
          באתר זה הינם בכפוף להוראות ולתנאים המפורטים באתר בכפוף לתקנון. השימוש
          במחשבון מהווה אישור והסכמה של המשתמש לתנאים האמורים לעיל.
        </Typography>
      </Box>
    </Box>
  );
};

export default TermsAndConditions;
